<template>
  <div class="overflow-y-scroll">
    <!--    <h3>{{ panelTitle }}</h3>-->
    <section>
      <div class="form-inline">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline">
        <label>Main Contact:</label>
        <div>
          <input type="text" placeholder="Email" v-model="editEmail" />
        </div>
      </div>
      <div class="form-inline">
        <label>Billing Contact:</label>
        <div>
          <input
            type="text"
            placeholder="Billing Email"
            v-model="editBillingEmail"
          />
        </div>
      </div>
      <div class="form-inline">
        <label>Rate:</label>
        <div>
          <input type="text" placeholder="Rate" v-model="editRate" />
        </div>
      </div>
      <div class="form-inline">
        <label>Active:</label>
        <div>
          <model-select
            :options="activeOptions"
            placeholder="Active"
            v-model="editIsActive"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Signed:</label>
        <div>
          <model-select
            :options="signedOptions"
            placeholder="Signed"
            v-model="editSigned"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Stripe ID:</label>
        <div>
          <input type="text" placeholder="Strip ID" v-model="editStripeId" />
        </div>
      </div>
      <div class="form-inline">
        <label>URL:</label>
        <div>
          <input type="text" placeholder="URL" v-model="editUrl" />
        </div>
      </div>
      <div class="form-inline">
        <label>About:</label>
        <div>
          <textarea rows="3" placeholder="about" v-model="editAbout" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <!-- <button class="submit primary" @click="buttonClick">{{buttonLabel}}</button> -->
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["propsData", "submitLoading"],
  components: {
    ModelSelect,
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editType: null,
      editName: null,
      editEmail: null,
      editBillingEmail: null,
      editRate: null,
      editIsActive: null,
      editStripeId: null,
      editUrl: null,
      editAbout: null,
      activeOptions: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      editSigned: null,
      signedOptions: [
        { text: "true", value: true },
        { text: "false", value: false },
      ],
    };
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.type;
      if (this.editType == "add") {
        this.panelTitle = "Add Company";
        this.buttonLabel = "Add Company";
      }
      if (this.editType == "edit") {
        this.panelTitle = "Edit Company";
        this.buttonLabel = "Edit Company";
      }
      this.editName = this.propsData.name;
      this.editEmail = this.propsData.email;
      this.editBillingEmail = this.propsData.billing_email;
      this.editRate = this.propsData.rate;
      this.editIsActive = this.propsData.is_active;
      this.editStripeId = this.propsData.stripe_id;
      this.editAbout = this.propsData.about;
      this.editSigned = this.propsData.signed;
      this.editUrl = this.propsData.url;
    },
    buttonClick: function () {
      const data = {
        type: this.editType,
        name: this.editName,
        email: this.editEmail,
        billingEmail: this.editBillingEmail,
        rate: this.editRate,
        isActive: this.editIsActive,
        stripeId: this.editStripeId,
        about: this.editAbout,
        signed: this.editSigned,
        url: this.editUrl,
      };
      this.$emit("closePanel");
      this.$emit("buttonClick", data);
    },
  },
};
</script>
